import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import {
  LS_ADMIN_DETAILS,
  LS_IMPERSONATION_ACTIVE,
  LS_IS_MAIN_NAV_ENABLE_FORCED,
  LS_OPERATOR_ID,
  LS_OPERATOR_STATUS,
  LS_USER_EMAIL,
  LS_USER_NAME,
  LS_USER_ROLE,
} from 'src/app/services/local-storage.service';
import { AccountService } from './services/account.service';
import { CommonService } from './services/common.service';
import { EventService } from './services/event.service';
import { LocalStorageService } from './services/local-storage.service';

const blackListedUrlsForNavbar = [
  'carpark/create',
  'account',
  'admin-dashboard',
];
const whiteListedUrlsForNavbar = ['profile', '/admin/'];

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'ezpark-portal';
  isNavBarEnabled = true;
  routingSub: Subscription;
  showSpinner: boolean = false;
  spinnerToggleCount: number = 0;
  mainNavChangeSub: Subscription;

  constructor(
    private router: Router,
    private cmnSrv: CommonService,
    private evtSvc: EventService,
    private lsSrv: LocalStorageService,
    public accountService: AccountService
  ) {}

  ngOnInit() {
    this.routingSub = this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.isNavBarEnabled = !blackListedUrlsForNavbar.some((e) =>
          val.url.includes(e)
        );
        this.isNavBarEnabled =
          this.isNavBarEnabled ||
          whiteListedUrlsForNavbar.some((e) => val.url.includes(e));

        // the carpark creation screens needs main navbar in edit mode;
        const isNavEnableForced =
          this.lsSrv.getItem(LS_IS_MAIN_NAV_ENABLE_FORCED) === '1';
        if (isNavEnableForced) this.isNavBarEnabled = true;
      }
    });

    this.mainNavChangeSub = this.cmnSrv.mainNavDisplayStatus$.subscribe(() => {
      // the carpark creation screens needs main navbar in edit mode;
      const isNavEnableForced =
        this.lsSrv.getItem(LS_IS_MAIN_NAV_ENABLE_FORCED) === '1';
      if (isNavEnableForced) this.isNavBarEnabled = true;
    });

    this.evtSvc.eventObservable.subscribe((eventState) => {
      if (eventState.name === 'add-loader') {
        this.spinnerToggleCount++;
      } else if (eventState.name === 'remove-loader') {
        this.spinnerToggleCount--;
      } else {
        return;
      }
      this.spinnerToggleCount =
        this.spinnerToggleCount < 0 ? 0 : this.spinnerToggleCount;
      setTimeout(() => {
        this.showSpinner = this.spinnerToggleCount > 0;
      }, 200);
    });
  }

  ngOnDestroy(): void {
    this.routingSub.unsubscribe();
    this.mainNavChangeSub.unsubscribe();
  }

  turnOffImpersonation() {
    this.accountService.isImpersonating = false;
    this.lsSrv.setItem(LS_IMPERSONATION_ACTIVE, '0');
    const adminDetails = JSON.parse(
      this.lsSrv.getItem(LS_ADMIN_DETAILS) || '0'
    );
    if (adminDetails) {
      this.lsSrv.setItem(LS_USER_EMAIL, adminDetails.userEmail);
      this.lsSrv.setItem(LS_USER_ROLE, adminDetails.userRole);
      this.lsSrv.setItem(LS_USER_NAME, adminDetails.userName);
      this.lsSrv.setItem(LS_OPERATOR_STATUS, adminDetails.operatorStatus);
      this.lsSrv.setItem(LS_OPERATOR_ID, adminDetails.operatorId);
      window.location = <any>'/admin-dashboard';
    }
  }
}
